import { PublicClientApplication } from '@azure/msal-browser';

const MSAL_CONFIG = {
  auth: {
    clientId: process.env.MICROSOFT_CLIENT_ID_AUTH,
    redirectUri: process.env.MICROSOFT_CLIENT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

const myMSALObj = new PublicClientApplication(MSAL_CONFIG);

class AzureAuthenticationContext {
  constructor() {
    this.setRequestObjects();
  }

  setRequestObjects = () => {
    this.loginRequest = {
      scopes: ['user.read', 'profile', 'openid', 'email'],
      prompt: 'select_account',
    };
    this.loginRedirectRequest = {
      ...this.loginRequest,
      redirectStartPage: window.location.href,
    };
  }

  login = (signInType, setUser, onError) => {
    if (signInType === 'loginPopup') {
      onError(null); // Clearing the error
      myMSALObj
        .loginPopup(this.loginRequest)
        .then((resp) => {
          this.handleResponse(resp, setUser);
        })
        .catch((err) => {
          if (err.errorCode === 'interaction_in_progress') {
            onError('Interaction is currently in progress. We have cancelled the interaction for you. Attempt to login again');
          } else onError(err.errorMessage);
          sessionStorage.clear();
        });
    } else if (signInType === 'loginRedirect') {
      this.myMSALObj.loginRedirect(this.loginRedirectRequest);
    }
  }

  handleResponse = (response, incomingFunction) => {
    if (response !== null && response.account !== null) {
      incomingFunction(response, myMSALObj);
    }
  }
}

export default AzureAuthenticationContext;



// WEBPACK FOOTER //
// ./client/app/screens/login/azure/azure-authentication-context.js